// extracted by mini-css-extract-plugin
module.exports = {"section":"HeroSection_section__wYDTr","title":"HeroSection_title__NgDdR","subtitle":"HeroSection_subtitle__cg8cK","paragraph":"HeroSection_paragraph__cazmp"};